<template>
	<div class="floatBox">
		<!--  -->
		<div class="box1" >
			<a target="_blank" :href=" 'tencent://message/?uin='+currentQQ+'&Site=qq&Menu=yes' ">
				
				<el-popover style='white-space: pre-line;' title='业务咨询' placement="bottom" width='200' trigger='hover'
				content="2860744669">
				<div slot="reference">
					<p class="icon">
						<img src="@/assets/QQ.png" />
					</p>
						<p class="font2" >业务咨询</p>
				</div>
				</el-popover>
			</a>
		</div>
		<div class="box2" >
			
			<el-popover style='white-space: pre-line;' title='客服电话' placement="bottom" width='200' trigger='hover' 
			content="0579-85836026">
			<div  slot="reference">
				<p class="icon">
					<img src="@/assets/fudongPhone.png" alt />
				</p>
					<p class="font2">客服电话</p>
			</div>
			</el-popover>
			
		</div>

		<div class="box1" @click='up'>
			<p class="icon">
				<img width="20" height="20" src="@/assets/fudongTop.png" />
			</p>
			<p class="font">返回顶部</p>
		</div>
		<div class="box" v-show='flag'>
			<h2 class="phones">0579-85836026</h2>
			<p class="spanColor">工作时间：周一至周五 09：00 - 17：30</p>
		</div>
		<div class="box3" v-show='flags'>
			<p class="spanColor">2860744669</p>
		</div>
		<!-- <div class="box3" v-show='flags' >
          <p class="spanColor">QQ：190436846</p>
      </div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				flag: false,
				flags: false,
				currentQQ:'2860744669',
			}
		},
		methods: {
			copyText(str) {
			      const oInput = document.createElement('input')
				  let tip = ''
				  if(str == 'qq'){
					  oInput.value = this.currentQQ
					  tip = 'QQ号复制成功'
				  }else{
					  oInput.value = '0579-85836026'
					  tip = '联系方式复制成功'
				  }
			      document.body.appendChild(oInput)
			      oInput.select()
			      document.execCommand('Copy')
			      this.$message({
			        message: tip,
			        type: 'success'
			      })
			      oInput.remove()
			},
			mouseoves(str) {
				if (str == 'qq') {
					this.flags = true
				} else {
					this.flag = true
				}
				this.copyText(str)

			},
			mouseleave(str) {
				if (str == 'qq') {
					this.flags = false
				} else {
					this.flag = false
				}

			},
			up() {
                // document.body.scrollTop = document.documentElement.scrollTop = 0;
                this.$emit("getTop");
			}
		}
	}
</script>

<style lang='less' scoped>
	.floatBox {
		position: relative;
		z-index: 99;
		cursor: default;

		.box {
			padding: 17px;
			width: max-content;
			height: auto;
			// background: #fff;
			position: absolute;
			right: 70px;
			bottom: -65px;
			// border-radius: 20px;
			background: #FFFFFF;
			border: 1px solid rgba(0, 0, 0, 0.10);
			box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.10);
			border-radius: 4px;
			// border-radius: 4px;
			font-size: 10px;
			color: black;

			.phones {
				font-size: 15px;
			}

			.spanColor {
				font-size: 15px;
				color: #808080;
			}
		}

		.box3 {
			padding: 17px;
			width: max-content;
			height: auto;
			// background: #fff;
			position: absolute;
			right: 70px;
			bottom: 0px;
			// border-radius: 20px;
			background: #FFFFFF;
			border: 1px solid rgba(0, 0, 0, 0.10);
			box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.10);
			border-radius: 4px;
			// border-radius: 4px;
			font-size: 10px;
			color: black;

			.spanColor {
				font-size: 15px;
				color: #808080;
			}
		}

		div {
			width: 75px;
			height: 64px;
			text-align: center;
			color: #fff;
		}

		.box1 {
			background: #3281FF;

		}

		.box2 {
			background: #1163E7;
		}

		.icon {
			font-size: 30px;

			img {
				margin-top: 13px;
			}
		}

		.font {
			font-size: 11px;
			color: white;
			background: #3281FF;
		}

		.icon2 {
			font-size: 30px;
			background: #1163E7;

		}

		.font2 {
			font-size: 11px;
		}

		.el-icon-phone {
			background: #1163E7;
		}
	}
</style>
